module.exports = __webpack_public_path__ + "img/footer-3.976addde.png";